import { useNavigate } from 'react-router-dom';
import React from "react";
import herosection from "../../images/herosection.jpg";
import Chip from "../chip/Chip";

export default function HeroSection({title, description, buttonLabel, buttonUrl}) {
  const navigate = useNavigate();

  if (!title || !description) {
    console.warn("HeroSection component requires both title and description props.");
    return null;
  }

  const renderButton = () => {
    if (buttonLabel && buttonUrl) {
      return (
        <div className="mt-6 flex items-center gap-x-4 sm:gap-x-6">
          <Chip onClick={() => navigate({buttonUrl})} label={buttonLabel} largeFont className="bg-primary text-white rounded-full"/>
        </div>
      )
    }
  }

  return (
    <div className="relative w-full min-h-[32rem] md:h-[34rem] lg:h-[36rem] xl:h-[40rem] overflow-hidden">
      <img src={herosection} alt="Hero background" className="absolute inset-0 w-full h-full object-cover z-0"/>
      <div className="absolute inset-0 bg-black bg-opacity-40 z-10">
        <div className="relative z-20 flex items-center h-full px-4 sm:px-6 md:px-10 lg:px-16">
          <div className="max-w-lg text-white">
            <h1 className="mt-4 text-pretty font-segoe text-[2rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[3.5rem] font-semibold tracking-tight">
              {title}
            </h1>
            <p className="mt-4 text-pretty font-segoe text-base sm:text-lg md:text-xl leading-snug sm:leading-normal">
              {description}
            </p>
            {renderButton()}
          </div>
        </div>
      </div>
    </div>
  );
}
